import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Compose Tailwind class names, merging duplicates safely. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
